import { breakpoints } from '@bnnvara/breakpoints';
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const NPOLink = styled.p`
  font-size: 16px;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${breakpoints.md} {
    font-size: 18px;
  }

  ${breakpoints.lg} {
    font-size: 20px;
  }

  a {
    color: red;
  }
`;
